export * from './sidebar.directive';



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/directives/sidebar/index.ts